<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10"
        clearable
        v-model="province"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in region"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-select
        class="mr10"
        clearable
        v-model="city"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in cityList"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-select
        class="mr10"
        clearable
        v-model="area"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in areaList"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="190px" align="center" label="培训封面">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        header-align="center"
        label="活动标题"
      ></el-table-column>
      <el-table-column prop="name" label="发布者" header-align="center">
      </el-table-column>
      <el-table-column prop="username" align="center" label="举办时间">
        <template #default="scope">
          <li>
            {{ $utils.formatDate(scope.row.startTime, "yyyy-MM-dd hh:mm") }}
          </li>
          <li>
            {{ $utils.formatDate(scope.row.endTime, "yyyy-MM-dd hh:mm") }}
          </li>
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="活动地址">
        <template #default="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column label="活动人数" align="center">
        <template #default="scope">{{ scope.row.maxNumber }}人 </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template #default="scope">
          <li class="status">
            {{ scope.row.status === 0 ? "已下架" : "已上架" }}
            <span v-if="scope.row.auditStatus === 3" class="prohibit"
              >禁止展示</span
            >
          </li>
        </template>
      </el-table-column>
      <el-table-column label="查看详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="text" @click="getInfo(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.auditStatus === 1"
            @click="handleEdit(scope.row.id, 1)"
            >禁止展示</el-button
          >
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.auditStatus === 3"
            @click="handleEdit(scope.row.id, 2)"
            >恢复展示</el-button
          >

          <el-button type="danger" size="mini" @click="delData(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      title="活动详情"
      v-model="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <div class="cover-title">
          <div
            class="cover"
            :style="`background-image:url(${$utils.fileUrl(itemData.cover)})`"
          ></div>
          <div class="title-name">
            <li>活动标题：{{ itemData.title }}</li>
            <li>发布者：{{ itemData.name }}</li>
          </div>
        </div>
        <div class="time-status">
          <li>
            {{ itemData.status === 0 ? "已下架" : "已上架" }}
            <span> {{ itemData.maxNumber }}人 </span>
          </li>
          <li>
            活动时间：
            {{ $utils.formatDate(itemData.startTime, "yyyy-MM-dd hh:mm") }}~
            {{ $utils.formatDate(itemData.endTime, "yyyy-MM-dd hh:mm") }}
          </li>
          <li>活动地点：{{ itemData.address }}</li>
        </div>
        <div class="remark">
          <li class="title">活动说明</li>
          <div class="remark-content">
            <p v-html="itemData.remark"></p>
          </div>
        </div>
        <li class="title">信用条件</li>
        <div class="credit">
          <ul>
            <li v-if="itemData.xinfuCertification === 1">
              <span class="value">诚信认证：</span>
              <span class="value"
                >{{
                  itemData.xinfuCertificationYear.replace(/,/g, "年度、")
                }}年度</span
              >
            </li>
            <li>
              <span class="value" v-if="itemData.xinfuAgreement === 1"
                >信夫履约分：{{ score(itemData.xinfuAgreementScore) }}</span
              >
            </li>
            <li v-if="itemData.xinfuLoans === 1">
              <span class="value"
                >信夫信贷分：{{ score(itemData.xinfuLoansScore) }}</span
              >
            </li>
            <li v-if="itemData.xinfuIntegration === 1">
              <span class="value"
                >信夫综合分：{{ score(itemData.xinfuIntegrationScore) }}</span
              >
            </li>
            <li v-if="itemData.xinfuPersonLoans === 1">
              <span class="value"
                >个人信贷分：{{ score(itemData.xinfuPersonLoansScore) }}</span
              >
            </li>
            <li v-if="itemData.xinfuPersonProfession === 1">
              <span class="value"
                >个人职信分：{{
                  score(itemData.xinfuPersonProfessionScore)
                }}</span
              >
            </li>
          </ul>
        </div>

        <el-table
          :data="listData.records"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
        >
          <el-table-column prop="name" header-align="center" label="报名用户">
          </el-table-column>
          <el-table-column align="center" label="用户类别">
            <template #default="scope">
              {{ targetType(scope.row.targetType) }}
            </template>
          </el-table-column>
          <el-table-column prop="personNumber" label="报名数" align="center">
          </el-table-column>
          <el-table-column align="center" label="审核状态">
            <template #default="scope">
              {{ status(scope.row.status) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="listData.current"
            :page-size="2"
            :total="listData.total"
            @current-change="getPage"
          ></el-pagination>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      dialogVisible: false,
      cityList: [],
      areaList: [],
      province: "",
      city: "",
      area: "",
      itemData: {},
      listData: {},
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        content: this.searchName,
        province: this.province,
        city: this.city,
        area: this.area,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.event.adopt.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    handleEdit(id, status) {
      if (!this.loading) {
        const text = status === 1 ? "是否确认禁止展示？" : "是否确认恢复？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
              status: status,
            };
            const res = await this.$api.event.adopt.setStatus(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    // 删除
    delData(id) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          this.$loading.start();
          const params = {
            id: id,
          };
          const res = await this.$api.event.adopt.delData(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    async getInfo(data) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const params = {
          id: data.id,
          currentPage: 1,
          pageSize: 10,
        };
        const res = await this.$api.event.adopt.getInfo(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.itemData = res.data.activity;
          this.listData = res.data.page;
          this.dialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    async getPage(page) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const params = {
          id: this.itemData.id,
          currentPage: page,
          pageSize: 10,
        };
        const res = await this.$api.event.adopt.getPage(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.listData = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    targetType(type) {
      switch (type) {
        case 1:
          return "个人";
        case 2:
          return "公司";
        case 3:
          return "团体";
      }
    },
    status(status) {
      switch (status) {
        case -1:
          return "不需审核";
        case 0:
          return "待审核";
        case 1:
          return "审核通过";
        case 2:
          return "审核失败";
      }
    },
    score(type) {
      switch (type) {
        case 1:
          return "200分以上";
        case 2:
          return "400分以上";
        case 3:
          return "600分以上";
        case 4:
          return "800分以上";
      }
    },
  },
  created() {
    this.getData();
  },
  computed: {
    region() {
      return this.$utils.getRegion();
    },
  },
  watch: {
    province: {
      handler(val, ovl) {
        this.region.forEach((item) => {
          if (item.label === val) {
            this.cityList = item.children;
          }
        });
      },
    },
    city: {
      handler(val, ovl) {
        this.cityList.forEach((item) => {
          if (item.label === val) {
            this.areaList = item.children;
          }
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.status {
  height: 90px;
  line-height: 90px;
  position: relative;
  .prohibit {
    left: 0;
    width: 100%;
    display: inline-block;
    position: absolute;
    color: #fa6164;
    font-size: 1.5rem;
    transform: rotate(30deg);
  }
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  .time-status {
    padding-top: 24px;
    li {
      line-height: 26px;

      span {
        margin-left: 50px;
      }
    }
  }

  .title {
    margin: 24px 0;
    padding-left: 10px;
    font-size: 1.125rem;
    border-left: 2px solid #409eff;
  }
  .remark {
    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
  .credit {
    display: flex;
    margin-bottom: 24px;
    span {
      line-height: 32px;
      font-size: 0.875rem;
    }
    .value {
      color: #666666;
    }
  }
}
</style>